import { render, staticRenderFns } from "./LiveVideoData.vue?vue&type=template&id=48365a6d&scoped=true"
import script from "./LiveVideoData.vue?vue&type=script&lang=js"
export * from "./LiveVideoData.vue?vue&type=script&lang=js"
import style0 from "./LiveVideoData.vue?vue&type=style&index=0&id=48365a6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48365a6d",
  null
  
)

export default component.exports